import { render, staticRenderFns } from "./mobiledisplay.vue?vue&type=template&id=c6d64a92&"
import script from "./mobiledisplay.vue?vue&type=script&lang=js&"
export * from "./mobiledisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports